<div class="criticalMass">
  <div style="display: flex">
    <h1>Critical Mass</h1>
    <mat-icon
      class="info-icon"
      matTooltip="Represents the lowest number of individuals required to successfully adopt the change.​"
      matTooltipPosition="above"
    >
      info
    </mat-icon>
  </div>
  <div class="progress">
    <label for="rating">{{ criticalMass }} of 20</label>
    <div
      *ngFor="let bar of progressCriticalMass; let i = index"
      class="progress-wrapper"
    >
      <!-- Progress bar -->
      <div
        class="progressBar"
        [ngClass]="{
          'pink-bar': i < criticalMass,
          'golden-bar': i === 15 && i >= criticalMass
        }"
      ></div>
      <!-- Critical Mass label for bar 16 (index 15) -->
      <div *ngIf="i === 15" class="critical-mass-label">Critical Mass</div>
    </div>
  </div>
</div>
